const selectedLabels = (values = {}) => (
	Object.entries(values)
		.filter(([, selected]) => selected)
		.map(([label]) => label)
)

export const resolveGlobalAnnotationRules = (annotations = {}) => {
	const configured = annotations?.globalAnnotationRules || {}
	const groupByAnnotation = {}
	const groups = []

	if (Array.isArray(configured.mutexGroups)) {
		configured.mutexGroups.forEach((group, index) => {
			if (!group || !Array.isArray(group.annotations)) return
			const name = typeof group.name === "string" && group.name.trim()
				? group.name.trim()
				: `Group ${index + 1}`
			const annotationsInGroup = []
			group.annotations.forEach((label) => {
				if (typeof label !== "string" || groupByAnnotation[label] !== undefined) return
				groupByAnnotation[label] = index
				annotationsInGroup.push(label)
			})
			groups.push({ name, annotations: annotationsInGroup })
		})
	}

	return {
		requireAtLeastOne: configured.requireAtLeastOne === true,
		mutexEnabled: configured.mutexEnabled === true,
		mutexGroups: groups,
		groupByAnnotation,
	}
}

export const validateGlobalAnnotations = (values, annotations) => {
	const rules = resolveGlobalAnnotationRules(annotations)
	const selected = selectedLabels(values)
	if (rules.requireAtLeastOne && selected.length === 0) {
		return { valid: false, message: "Select at least one global annotation before saving." }
	}
	if (rules.mutexEnabled) {
		const selectedGroups = new Set(
			selected.map((label) => rules.groupByAnnotation[label]).filter((group) => group !== undefined)
		)
		if (selectedGroups.size > 1) {
			return { valid: false, message: "Selected global annotations belong to mutually exclusive groups." }
		}
	}
	return { valid: true, message: "" }
}

export const isGlobalAnnotationDisabled = (label, values, annotations) => {
	const rules = resolveGlobalAnnotationRules(annotations)
	if (!rules.mutexEnabled || values?.[label]) return false
	const targetGroup = rules.groupByAnnotation[label]
	if (targetGroup === undefined) return false
	return selectedLabels(values).some((selected) => {
		const selectedGroup = rules.groupByAnnotation[selected]
		return selectedGroup !== undefined && selectedGroup !== targetGroup
	})
}
